import { Roles } from '../../helpers/utility';

let options = [
	{
		key: 'Home',
		label: 'sidebar.HomePageLabel',
		leftIcon: 'ion-android-home',
	},
	{
		key: 'Space_001',
		space: 'DKO',
	},
	{
		key: 'Separator_001',
		separatorTitle: "sidebar.customerArea",
	},
	{
		key: 'DataStudio',
		label: 'contact.SBDataStudio',
		leftIcon: 'ion-speedometer',
		APIKey: 'DataStudioTab'
	},
	{
		key: 'QlikSenseDashboard',
		label: 'contact.SBQlikSenseDashboard',
		leftIcon: 'ion-speedometer',
		APIKey: 'QlikSenseDashboardTab',

	},
	{
		key: 'QlikSenseReport',
		label: 'contact.SBQlikSenseReport',
		leftIcon: 'ion-clipboard',
		APIKey: 'QlikSenseReportTab',

	},
	{
		key: 'ContractOrganization',
		label: 'sidebar.ContractOrganization',
		leftIcon: 'ion-person',
		APIKey: 'OrganigramaTab'
	},
	{
		key: 'Trips',
		label: 'sidebar.Trips',
		leftIcon: 'ion-android-bus',
		APIKey: 'TripsTab'
	},
	{
		key: 'Dashboard',
		label: 'forms.progressBar.dashboardTitle',
		leftIcon: 'ion-speedometer',
		APIKey: 'DashboardTab',
		visibleBy: [Roles.ADMIN, Roles.BACKOFFICE, Roles.CLIENTGENERATOR]
	},
	{
		key: 'Contracts',
		label: 'sidebar.Contracts',
		leftIcon: 'ion-clipboard',
		APIKey: 'ContractsTab',
		visibleBy: [Roles.ADMIN, Roles.BACKOFFICE, Roles.CLIENTGENERATOR]
	},
	{
		key: 'SearchDocuments',
		label: 'sidebar.searchDocuments',
		leftIcon: 'ion-search',
		APIKey: 'SearchDocsTab'
	},
	{
		key: 'Veocob',
		label: 'sidebar.Veocob',
		leftIcon: 'ion-wifi',
		external: true,
		APIKey: 'VeocobTab'
	},
	{
		key: 'Space_002',
		space: 'DKO',
	},
	{
		key: 'Separator_002',
		separatorTitle: "sidebar.restrictedArea",
		visibleBy: [Roles.ADMIN, Roles.BACKOFFICE]
	},
	{
		key: 'BackOffice',
		label: 'sidebar.backOffice',
		leftIcon: 'ion-android-settings',
		children: [
			{
				key: 'Users',
				label: 'sidebar.users',
			},
			{
				key: 'Utilizadores',
				label: 'sidebar.contacts',
			},
			{
				key: 'Companies',
				label: 'sidebar.Companies',
			},
			{
				key: 'BusPartner',
				label: 'backoffice.BusinessParnter',
			},
			{
				key: 'BusPartnerSite',
				label: 'backoffice.BusinessParnterSite',
			},
			{
				key: 'Countries',
				label: 'backoffice.Countries',
			},
			{
				key: 'Logs',
				label: 'sidebar.logs',
			},
			{
				key: 'EmailLogs',
				label: 'sidebar.emailLogs',

			},
			{
				key: 'LoginLogs',
				label: 'sidebar.loginLogs',

			},
			{
				key: 'ContentManagement',
				label: 'backoffice.contentManagement',

			},
			{
				key: 'Settings',
				label: 'sidebar.Settings',
			},
		],
		visibleBy: [Roles.ADMIN, Roles.BACKOFFICE]
	},
];

export default options;
